const shippingRegionCache = new Map();

export function buildShippingRegionCacheKey(provinceCode = '', cityCode = '') {
  return `${String(provinceCode || '').trim()}|${String(cityCode || '').trim()}`;
}

export function getShippingRegionCache(provinceCode = '', cityCode = '') {
  return shippingRegionCache.get(buildShippingRegionCacheKey(provinceCode, cityCode));
}

export function setShippingRegionCache(provinceCode = '', cityCode = '', value = []) {
  const cacheKey = buildShippingRegionCacheKey(provinceCode, cityCode);
  shippingRegionCache.set(cacheKey, value);
  return value;
}
